import { Field } from 'formik';
import { Form } from 'react-bootstrap';
import { FormLabel, FormStepHeader } from '../../../components/forms';
import { PasswordField } from '../../../components/inputs/PasswordField';
import { heardAboutUsOptions } from '../../../utils/consts';
import { StepProps } from '../Register';

export const FinalizeForm = ({ touched, errors }: StepProps) => {
  return (
    <>
      <FormStepHeader title="Finalize" />

      <PasswordField
        name="password"
        label="Password"
        required
      />
      <PasswordField
        name="confirm_password"
        label="Confirm Password"
        required
      />

      <Form.Group
        className="mb-lg-3 mb-1"
        controlId="heard_about"
      >
        <FormLabel>How did you hear about us?</FormLabel>
        <Field
          name="heard_about"
          as={Form.Select}
          options={['2', '3']}
          placeholder="Select"
          isInvalid={touched.heard_about && !!errors.heard_about}
        >
          <option>Select</option>
          {heardAboutUsOptions.map((opt) => (
            <option
              value={opt}
              key={opt}
            >
              {opt}
            </option>
          ))}
        </Field>
      </Form.Group>
    </>
  );
};
